<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Footer",
  data() {
    return {
    }
  },
  methods:{
    handleItemClick(event, path){
      const target = event.target
      if (target.tagName.toLowerCase() === 'span') {
        this.$router.push(path).catch(err => {
          if(err.name !== 'NavigationDuplicated'){
            throw err
          }
        })
      }
    }
  },
  computed:{
    menuItem(){
      return [
        { path: '/', name: this.$t('menu.home')},
        { path: '/About', name: this.$t('menu.about')},
        { path: '/ContactUs', name:this.$t('menu.contact')}
      ]
    }
  }
}
</script>

<template>
<div class="footer-container">
  <div class="footer-who footer-padding">
    <div class="who-one">
      <p v-html="$t('footer.address')"/>
      <p><a href="tel:(852) 3563-6771">{{$t('footer.tel')}}</a></p>
      <p><a href="mailto:enquiry@ppmember.com">{{$t('footer.email')}}</a></p>
    </div>
    <div class="who-two">
      <div>
        <h5>{{$t('footer.siteMap')}}</h5>
        <el-menu class="menu">
          <el-menu-item v-for="item in menuItem" :index="item.path" :key="item.path" @click.native.prevent="handleItemClick($event, item.path)">
            <span>{{item.name}}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="who-three">
      <h5>{{$t('footer.connect')}}</h5>
      <div style="display: flex; align-items: center;  column-gap: 10px">
        <a href="https://www.facebook.com/profile.php?id=61586638316207&locale=zh_HK" target="_blank"><img src="@/assets/images/footer/social_03_03.webp" alt="" class="mw-100"></a>
        <a href="https://www.instagram.com/monkeytreeprivilegehk?igsh=Mnlqb3FqNWphYmx3" target="_blank"><img src="@/assets/images/footer/social_03_05.webp" alt="" class="mw-100"></a>
        <a href="https://www.youtube.com/user/monkeytreehk" target="_blank"><img src="@/assets/images/footer/social_03_09.webp" alt="" class="mw-100"></a>
      </div>
    </div>
  </div>
  <div class="footer-copyright footer-padding">
    <span>{{$t('footer.copyRight')}}</span>
    <span>
      <el-link :underline="false" @click="$router.push({path: '/Privacy'})">{{$t('footer.privacy')}}</el-link> |
      <el-link :underline="false" @click="$router.push({path: '/term'})">{{$t('footer.termUse')}}</el-link>
    </span>
  </div>
  <div class="what-app">
    <a target="_blank" href="https://wa.me/85296578099?text=%E4%BD%A0%E5%A5%BD">
      <img class="mw-100" src="@/assets/images/footer/whatsapp_online.png" alt="">
    </a>
  </div>
  <el-backtop :bottom="100">
    <img class="mw-100" src="@/assets/images/footer/f-assets-MT-HP-topbutton-01.png" alt="">
  </el-backtop>
</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.footer-container{
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .footer-padding{
    padding: 0 360px;
    @media (max-width: 1599px) {
      padding: 0 30px;
    }
  }
  .footer-who{
    background: #99d355;
    padding-top: 2%;
    padding-bottom: 2%;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .who-one{
      padding-right: 5%;
      a{
        color: #FFFFFF;
      }
    }
    .who-two{
      h5{
        color: #20962d;
        font-size: 18px;
      }
      flex: 2;
      padding: 0 5%;
      border: 1px solid #006837;
      border-top: none;
      border-bottom: none;
      span{
        cursor: pointer;

        &:hover{
          opacity: .7;
          color: #009344;
        }
      }
      .el-menu{
        background: transparent;
        border: none;
        .el-menu-item{
          padding: 0 !important;
          //font-size: 14px;
          background: transparent;
          height: auto;
          line-height: 1.5;
          color: #FFFFFF;
          cursor: default;
        }
      }
    }
    .who-three{
      h5{
        color: #20962d;
        font-size: 18px;
      }
      flex: 1;
      padding-left: 5%;
    }
  }
  .footer-copyright{
    background: #0E762F 0% 0% no-repeat padding-box;
    padding-top: 3%;
    padding-bottom: 3%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #FFFFFF !important;
    a{
      color: #FFFFFF !important;
      font-size: 14px;
    }
  }
  .what-app{
    position: fixed;
    right: 40px;
    bottom: 150px;
    @media (max-width: 998px) {
      width: 40px;
      height: 40px;
      right: 29px;
    }
  }
  .el-backtop{
    width: auto;
    @media (max-width: 998px) {
      width: 40px;
      height: 40px;
      right: 29px !important;
    }
  }
}
@include media-max(md){
  .footer-container{
    .footer-who{
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 7%;
      padding-bottom: 5%;
      .who-one{
        padding-right: 0;
        text-align: center;
        font-size: 15px;
      }
      .who-two{
        margin-top: 1rem;
        border: none;

        h5{
          text-align: center;
          margin-bottom: 5px;
        }
        .menu{
          display: flex;
          column-gap: 20px;
          span{
            font-size: 15px;
          }
        }
      }
      .who-three{
        margin-top: 1rem;
        padding-left: 0;
        h5{
          text-align: center;
          margin-bottom: 5px;
        }
      }
    }
    .footer-copyright{
      flex-direction: column;
      font-size: 13px;
      row-gap: 10px;
      a{
        font-size: 13px;
      }
    }
  }
}
</style>